import { render, staticRenderFns } from "./CSenior.vue?vue&type=template&id=13b4761a"
import script from "./CSenior.vue?vue&type=script&lang=js"
export * from "./CSenior.vue?vue&type=script&lang=js"
import style0 from "./CSenior.vue?vue&type=style&index=0&id=13b4761a&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13b4761a')) {
      api.createRecord('13b4761a', component.options)
    } else {
      api.reload('13b4761a', component.options)
    }
    module.hot.accept("./CSenior.vue?vue&type=template&id=13b4761a", function () {
      api.rerender('13b4761a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CSenior.vue"
export default component.exports